/**
 * State machines, as tables.
 *
 * Appendix C names twelve and Appendix W writes them out in implementable form. Two are built
 * here, the two M1 needs. The other ten arrive with the milestone that uses them, rather than as
 * ten unused tables that drift from the appendix before anything reads them.
 *
 * A table is total: every state is a key, and a terminal state maps to an empty list. That is what
 * makes "no transition out of `superseded`" an assertion rather than an omission.
 */
/**
 * Whether `from → to` is an allowed edge.
 *
 * The lookup is guarded even though `Record<S, ...>` tells the compiler it cannot miss. `ARC-020`
 * requires application code to tolerate tenants sitting briefly on adjacent schema versions, so a
 * status column can hand back a value this build has never heard of. It arrives already cast at the
 * persistence boundary, where the type system has nothing left to check, and an unguarded lookup
 * turns that into a `TypeError` in the middle of a migration fan-out. Refusing the transition is
 * the correct answer and the caller's error path already handles it.
 *
 * `noUncheckedIndexedAccess` does not catch this: it exempts `Record` over a finite union, which is
 * exactly the shape here.
 */
export function canTransition(table, from, to) {
    return table[from]?.includes(to) ?? false;
}
//# sourceMappingURL=transition.js.map